import React, { useEffect, useRef } from "react";
import "./FinalMessage.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const FinalMessage: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // 初期状態を確実に設定
    if (textRef.current?.children) {
      gsap.set(textRef.current.children, { opacity: 1, y: 0 });

      gsap.fromTo(
        textRef.current.children,
        { opacity: 0, y: 50 },
        {
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            toggleActions: "play none none none",
            once: true,
          },
          opacity: 1,
          y: 0,
          stagger: 0.2,
          duration: 1,
          ease: "power3.out",
        },
      );
    }
  }, []);

  return (
    <section
      className="final-message"
      ref={sectionRef}
      aria-label="まとめメッセージ"
    >
      <div className="final-container">
        <div className="final-content" ref={textRef}>
          <h2 className="final-title">
            キレイな線にこだわった
            <br />
            eComicシリーズ
          </h2>
          <p className="final-text">
            繊細な線の美しさを大切に表現し、
            <br />
            読者が物語に没入できる体験をサポート。
          </p>
          <p className="final-highlight">
            電子コミックはより価値のあるものへと
            <br />
            生まれ変わります。
          </p>
        </div>
        <div className="final-decoration" aria-hidden="true">
          <div className="decoration-rect rect-1"></div>
          <div className="decoration-rect rect-2"></div>
          <div className="decoration-rect rect-3"></div>
          <div className="decoration-rect rect-4"></div>
          <div className="decoration-rect rect-5"></div>
          <div className="decoration-rect rect-6"></div>
        </div>
      </div>
    </section>
  );
};

export default FinalMessage;
